if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.daysBlock = this.querySelector('.countdown-timer__item[data-type=days] .numbers');
      this.daysNumbers = this.daysBlock.querySelectorAll('.number')
      this.hoursBlock = this.querySelector('.countdown-timer__item[data-type=hours] .numbers');
      this.hoursNumbers = this.hoursBlock.querySelectorAll('.number')
      this.minutesBlock = this.querySelector('.countdown-timer__item[data-type=minutes] .numbers');
      this.minutesNumbers = this.minutesBlock.querySelectorAll('.number')
      this.secondsBlock = this.querySelector('.countdown-timer__item[data-type=seconds] .numbers');
      this.secondsNumbers = this.secondsBlock.querySelectorAll('.number')

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split('-'),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour, tarmin;

      if (time != null) {
        time = time.split(':');
        tarhour = parseInt(time[0]);
        tarmin = parseInt(time[1]);
      }


      // Set the date we're counting down to
      let date_string = month + '/' + day + '/' + year + ' ' + tarhour + ':' + tarmin + ' ' + timezone;
      // Time without timezone
      this.countDownDate = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();

      // Time with timezone
      this.countDownDate = new Date(date_string).getTime();

    }

    convertDateForIos(date) {
      var arr = date.split(/[- :]/);
      date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      return date;
    }
    connectedCallback() {
      let _this = this;
      const updateTime = function () {

        // Get todays date and time
        const now = new Date().getTime();

        // Find the distance between now an the count down date
        const distance = _this.countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
          _this.updateValue(_this.daysNumbers, CountdownTimer.addZero(0), 'days');
          _this.updateValue(_this.hoursNumbers, CountdownTimer.addZero(0), 'hours');
          _this.updateValue(_this.minutesNumbers, CountdownTimer.addZero(0), 'minutes');
          _this.updateValue(_this.secondsNumbers, CountdownTimer.addZero(0), 'seconds');

        } else {
          requestAnimationFrame(updateTime);
          _this.updateValue(_this.daysNumbers, CountdownTimer.addZero(days), 'days');
          _this.updateValue(_this.hoursNumbers, CountdownTimer.addZero(hours), 'hours');
          _this.updateValue(_this.minutesNumbers, CountdownTimer.addZero(minutes), 'minutes');
          _this.updateValue(_this.secondsNumbers, CountdownTimer.addZero(seconds), 'seconds');
        }


      };
      requestAnimationFrame(updateTime);
    }
    updateValue(element, value, type) {
      const numbers = value.toString().split('');
      element.forEach((item, index) => {
        if (index < numbers.length) {
          let nextNumber = +numbers[index] + 1;
          if (type === 'seconds' || type === 'minutes') {
            if (index == 0 && nextNumber == 6) {
              nextNumber = 0;
            } else {
              if (nextNumber == 10)
                nextNumber = 0;
            }
          } else {
            if (nextNumber == 10)
              nextNumber = 0;
          }
          item.querySelectorAll('.number-list span').forEach((element) => {
            if (element.dataset.item == numbers[index]) {
              element.className = 'active'
            } else {
              if (element.dataset.item == nextNumber) {
                element.className = 'out'
              } else {
                element.className = ''
              }
            }
          })

        } else {
          item.style.display = 'none'
        }
      })
    }
    static addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}